<div class="container-fluid">
  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-users mr-2"></i>{{ menu.memberReportI18n }}
  </h1>

  <!-- Description -->
  <p class="lead mb-4">
    This report provides detailed information on members, including their types, contact details, and addresses. Use the filters below to customize your report based on user type and status. Click "Search" to generate the report.
  </p>

  <!-- Filters and Search Button -->
  <div class="card shadow mb-4">
    <div class="card-body">
      <select
        class="col-sm-2 custom-select"
        id="inputGroupSelect04"
        (change)="selectUserType($event.target.value)"
      >
        <option selected>Select User Type</option>
        <option value="{{ c }}" *ngFor="let c of userType$">
          {{ c }}
        </option>
      </select>

      <select
        class="col-sm-2 custom-select"
        id="inputGroupSelect04"
        (change)="selectStatus($event.target.value)"
      >
        <option selected>Select Status</option>
        <option value="{{ c }}" *ngFor="let c of status$">
          {{ c }}
        </option>
      </select>

      <button
        (click)="search()"
        href="#"
        role="button"
        class="btn btn-info btn-icon-split"
      >
        <span class="icon text-white-50">
          <i class="fas fa-filter"></i>
        </span>
        <span class="text">Filter</span>
      </button>
    </div>
  </div>

  <!-- Data Table -->
  <div class="card shadow mb-4" *ngIf="searchButtonClicked">
    <div class="card-body">
      <div class="table-responsive">
        <div class="export-buttons">
          <button class="btn btn-outline-primary" (click)="exportToCSV()">Export to CSV</button>
          <button class="btn btn-outline-secondary" (click)="exportToPDF()">Export to PDF</button>
        </div>
        <table
          class="table table-bordered"
          id="table"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>{{ memberI18n.nameI18n }}</th>
              <th>{{ memberI18n.type_idI18n }}</th>
              <th>{{ memberI18n.emailI18n }}</th>
              <th>{{ memberI18n.mobileI18n }}</th>
              <th>{{ memberI18n.addressI18n }}</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th>{{ memberI18n.nameI18n }}</th>
              <th>{{ memberI18n.type_idI18n }}</th>
              <th>{{ memberI18n.emailI18n }}</th>
              <th>{{ memberI18n.mobileI18n }}</th>
              <th>{{ memberI18n.addressI18n }}</th>
            </tr>
          </tfoot>
          <tbody>
            <tr *ngFor="let m of members">
              <td>{{ m.firstname+" "+m.Becker }}</td>
              <td>{{ m.typeId }}</td>
              <td>{{ m.primary_email }}</td>
              <td>{{ m.city }}</td>
              <td>{{ m.address }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
